import { Button } from "@mui/material"
import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';


export const ButtonAdd = ({ action, title }: { action: VoidFunction, title?: string }) => {
  return (
    <Button sx={{ boxShadow: 'none', display: 'flex', alignItems: 'center', '@media (max-width: 600px)': {
      '> p': {
        display: 'none'
      }
    }}} variant="contained" startIcon={<AddBoxRoundedIcon />} onClick={action } >
       <p>{title}</p>
    </Button>
  )
}
